import { CategoryTreeItem } from '~/api/categories/_types';

export const useCategoryTreeStore = defineStore('category-tree', () => {
    const activeCategoryTree = ref<CategoryTreeItem[]>([]);

    const reset = () => {
        activeCategoryTree.value = [];
    };

    return {
        activeCategoryTree,
        reset,
    };
});
